// Constants barrel export
export * from './api'
export * from './routes'
export * from './loadingMessages'

// Re-export all enums
export * from './enums'

// Re-export all string constants and mappings
export * from './strings'

// Legacy exports for backwards compatibility
export {
  SessionStatus,
  SessionSource,
  SessionResult,
  MFAStatus,
  MFAMethod,
  LifelineType,
  ItemStatus,
  CustomerPortalInputType,
  QuantityType,
  InputType,
  BillingCycleType,
  FulfillmentStatus,
  ItemPendingStatus,
  TrackingStatus,
  PaymentSource,
  TranResponse,
  FunnelItemStatus,
  InputState,
  ProductStatus,
  FulfillmentType,
  ProductType,
  ProcessType,
  VariantType,
  CancelItemsSelection,
  OrderPaymentOptions,
  SubscriptionDisplayType,
  MobileIconButtonType,
  PaymentUpdateAllowed,
  StepButtonType,
  CheckoutSteps,
  PopupCloseSetting,
  ContentWidthDeviceSize,
  LabelTypes,
  ShowBreadcrumbs,
  PreviewType,
  StepCategory,
} from './enums'

export {
  ItemStatusStrings,
  ItemStatusClasses,
  FulfillmentStatusStrings,
  FulfillmentStatusClasses,
  ItemPendingStatusStrings,
  TrackingStatusStrings,
  TrackingStatusDescriptionStrings,
  TrackingStatusMissingDeliverDateStrings,
  TrackingStatusClass,
  PaymentSourceStrings,
  TranResponseStrings,
  TranResponseBadgeClass,
  PaymentStatusStrings,
  PaymentStatusClasses,
  ManageSubscriptionIntents,
  StepsExcludedFromMouseflow,
  CheckoutStepsTitle,
  IntentLabels,
  ContentWidthDeviceSizeToClass,
  Countries,
  Regions,
  TranslateTestString,
  ForceLogoutErrorCodes,
  BASE_WIDTH,
  ExternalStepKey,
  MessageDisplayTime,
  CustomerMatchMessages,
  CustomerVerifyMessages,
  ActionMessages,
  IntentHierarchyCategory,
  IntentHierarchyLabels,
  IntentHierarchyMapping,
} from './strings'

/**
 * Responsive bands. Tablet shares the mobile design by default, but stays separately
 * targetable so either can be changed on its own. Mirrored by the CSS media queries —
 * see the breakpoint header in styles/index.css. Change both together.
 *
 *   phone      ≤ 767            @media (max-width: 767px)
 *   tablet     768 – 1024       @media (min-width: 768px) and (max-width: 1024px)
 *   compact    ≤ 1024           @media (max-width: 1024px)      ← the shared mobile design
 *   desktop    ≥ 1025           @media (min-width: 1025px)
 */
export const MOBILE_MAX_WIDTH = 767
export const TABLET_MAX_WIDTH = 1024
